module.exports = __webpack_public_path__ + "static/aboutus-3.ba15eb5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutus/aboutus-3.svg
// module id = 1084
// module chunks = 4035221647099